module.exports = __webpack_public_path__ + "img/bg2s.a355c9b4.png";